import { createStyles, makeStyles } from '@mui/styles';
import { ITheme } from 'theme/types';

const useTooltipCellStyles = makeStyles((theme: ITheme) =>
  createStyles({
    icon: {
      cursor: 'default',
    },
    tooltip: {
      backdropFilter: 'blur(6px)',
      backgroundColor: theme.palette.common?.white,
      borderRadius: 10,
      boxShadow: '0px 2.7px 16.2px 0px rgba(0,0,0,0.35)',
      color: theme.palette.common?.black,
      fontSize: `${theme.spacing(1.5)}px`,
      fontWeight: 600,
      lineHeight: `${theme.spacing(2)}px`,
      maxWidth: '222px',
      padding: '14px 8px',
    },
    arrow: {
      color: theme.palette.common?.white,
    },
    popper: {
      zIndex: 9999,
    },
  })
);

export default useTooltipCellStyles;
